import React, { useState, useEffect } from "react";
import { ReportAPI } from "../../api/apiClient";

interface Props {
  projectId: number;
  //selectedDate: string; // 👈 passed from dashboard
}

interface ReceiptItem {
  date: string;
  componentNo: number;
  component: string;
  unitName: string;
  receipt: number;
}

export default function DailyMaterialReceiptReport({
  projectId,
 // selectedDate,
}: Props) {
  const [data, setData] = useState<ReceiptItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // 🔥 Auto load when date changes
  useEffect(() => {
   // if (!selectedDate) return;
   if (!projectId) return;

    const loadReceipt = async () => {
      setLoading(true);

      try {
        const result = await ReportAPI.getMaterialReceipt({
          project: projectId,
          //fromDate: selectedDate,
          //toDate: selectedDate,
          vendor: -1,
          cmp: 0,
        });

        setData(result);
      } catch (error) {
        console.error("Material Receipt API Error:", error);
      }

      setLoading(false);
    };

    loadReceipt();
  }, [ projectId]); //selectedDate,

  


    return (
  <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">

    {/* Header */}
    <div className="bg-[#1788ac] text-white px-4 py-3 font-semibold">
      DAILY MATERIALS ON RECEIPT
    </div>

    {/* Body */}
   {/* <div className="bg-gray-100 p-6 min-h-[200px]">*/}
    <div className="bg-white p-6 min-h-[200px]">

      {loading && (
        <div className="text-gray-500 text-center">
          Loading...
        </div>
      )}

      {!loading && data.length === 0 && (
        <div className="text-gray-500 text-center">
          No material receipt available
        </div>
      )}

      {!loading && data.length > 0 && (
        <div className="space-y-6">
          {data.map((item) => (
            <div
              key={item.componentNo}
              className="text-center border-b pb-4 last:border-none"
            >
              <div className="text-gray-700 font-medium">
                {item.component}
              </div>

              <div className="text-2xl font-bold text-gray-900">
                {item.receipt.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                <span className="text-base font-medium">
                  {item.unitName?.trim()}
                </span>
              </div>

              <div className="text-xs text-gray-500">
                {new Date(item.date).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      )}

    </div>

  </div>
);







      {/* Bottom Accent */}
     {/* <div className="h-1 bg-green-600"></div>*/}
    
}
